// extracted by mini-css-extract-plugin
export default {"container":"who-are-we_container__FyY92","divider":"who-are-we_divider__QEicA","flexContainer":"who-are-we_flexContainer__Pgh-S"};